// extracted by mini-css-extract-plugin
export default {"main_":"ProductList_main___QOuRz","pesquisa":"ProductList_pesquisa__BpNDf","h2_":"ProductList_h2___j025k","img__protudo":"ProductList_img__protudo__Wqu9Z"};